<template>
  <div>
    <button class="btn btn-info mb-2" @click.prevent="openModal">
      <i class="fas fa-plus"></i> Chọn
    </button>
    <b-table bordered head-variant="dark" hover responsive :fields="fields" :items="items" table-variant="light">
      <template v-slot:cell(nhomthutuc)="data">
        <div
          v-if="thutucthoiviecs.length > 0 && nhomthutucs.length > 0"
        >{{nhomthutucs.find(x => x.id === thutucthoiviecs.find(x => x.id === data.item.procedureid).nhomthutuc).pickListValue}}</div>
      </template>
      <template v-slot:cell(tenthutuc)="data">
        <div
          v-if="thutucthoiviecs.length > 0"
        >{{thutucthoiviecs.find(x => x.id === data.item.procedureid).tenthutuc}}</div>
      </template>
      <template v-slot:cell(ngaytiepnhan)="data">{{data.item.ngaytiepnhan | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(action)="data">
        <button class="btn btn-info mr-2" @click="openUpdateItemModal(data)">
          <i class="fas fa-eye"></i>
        </button>
        <button class="btn btn-danger" @click="deleteItem(data)">
          <i class="fas fa-trash-alt"></i>
        </button>
      </template>
    </b-table>
    <thu-tuc-modal
      :show="modalShow"
      :items="thutucthoiviecsFilter"
      :nhomthutucs="nhomthutucs"
      @cancelModal="closeModal"
      @okModal="storeItem"
    />
    <b-modal
      v-model="modalUpdateShow"
      header-bg-variant="info"
      header-text-variant="light"
      hover
      responsive
      size="lg"
      title="Cập nhật thủ tục thôi việc"
      @ok="udpateItem"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="success" @click="ok()">Lưu</b-button>
        <b-button variant="danger" @click="cancel()">Đóng</b-button>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit="ok()">
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Tên thủ tục</label>
          </b-col>
          <b-col cols="9">
            <b-form-input readonly
              v-if="item_selected != null && thutucthoiviecs.length > 0"
              v-model="thutucthoiviecs.find(x => x.id === item_selected.procedureid).tenthutuc"
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Nhóm thủ tục</label>
          </b-col>
          <b-col cols="9">
            <b-form-input readonly 
              v-if="item_selected != null && thutucthoiviecs.length > 0 && nhomthutucs.length > 0" 
              v-model="nhomthutucs.find(x => x.id === thutucthoiviecs.find(x => x.id === item_selected.procedureid).nhomthutuc).pickListValue">
            </b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Ngày tiếp nhận</label>
          </b-col>
          <b-col cols="9">
            <vue-datepicker-local v-if="item_selected != null"
                v-model="item_selected.ngaytiepnhan"
                :local="local"
                clearable
                format="DD/MM/YYYY"
              />
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ThuTucModal from "./ThuTucModal";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
export default {
  name: "ThoiViec",
  props: ["item"],
  components: {
    ThuTucModal,
    VueDatepickerLocal
  },
  data() {
    return {
      modalShow: false,
      modalUpdateShow: false,
      items: [],      
      fields: [
        {
          key: "tenthutuc",
          label: "Tên thủ tục",
        },
        {
          key: "nhomthutuc",
          label: "Nhóm thủ tục",
        },
        {
          key: "ngaytiepnhan",
          label: "Ngày",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "150px !important" },
        },
      ],
      nhomthutucs: [],
      loaithutucs: [],
      thutucthoiviecs: [],
      item_selected: null,
      itemIdex: null,
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },      
    };
  },
  computed: {
    thutucthoiviecsFilter() {
      let result = [];
      if (this.items.length > 0) {
        let index;
        for (index = 0; index < this.thutucthoiviecs.length; ++index) {
          const thutuctiepnhan = this.thutucthoiviecs[index];
          const temp = this.items.filter(
            (x) => x.procedureid == thutuctiepnhan.id
          );
          if (temp.length <= 0) {
            result.push(thutuctiepnhan);
          }
        }
      } else {
        let index;
        for (index = 0; index < this.thutucthoiviecs.length; ++index) {
          const thutuctiepnhan = this.thutucthoiviecs[index];
          result.push(thutuctiepnhan);
        }
      }
      return result;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      axios
        .all([
          axios.get("/api/picklist/nhomthutuc"),
          axios.get(`/api/picklist/loaithutuc`),
          axios.get(`/api/employeequit/${this.item.id}`),
        ])
        .then(
          axios.spread((nhomthutucs, loaithutucs, employeequit) => {
            this.nhomthutucs = nhomthutucs.data;
            this.loaithutucs = loaithutucs.data;
            this.items = employeequit.data;
            const thutucthoiviecs = this.loaithutucs.filter(
              (x) => x.pickListValue == "Thủ tục thôi việc"
            );
            if (thutucthoiviecs.length > 0) {
              axios
                .get(`/api/procedure/loaithutuc/${thutucthoiviecs[0].id}`)
                .then((response) => {
                  this.thutucthoiviecs = response.data;
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
            }
          })
        )
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    openModal() {
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
    },
    storeItem(thutucsSelected) {
      this.modalShow = false;
      if (thutucsSelected.length > 0) {
        const payload = {
          thutucs: thutucsSelected,
          employeeid: this.item.id,
        };
        axios
          .post("/api/employeequit", payload)
          .then((res) => {
            let index;
            for (index = 0; index < res.data.length; ++index) {
              this.items.push(res.data[index]);
            }
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          });
      }
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/employeequit/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    openUpdateItemModal(data) {
      this.modalUpdateShow = true;
      this.item_selected = data.item;
      this.itemIdex = data.index;
    },
    udpateItem(bvModalEvt) {      
      axios
        .put("/api/employeequit", this.item_selected)
        .then((res) => {
          this.modalShow = false;
          this.items[this.itemIdex] = JSON.parse(
            JSON.stringify(this.item_selected)
          );
          const temp = JSON.parse(JSON.stringify(this.items));
          this.items = JSON.parse(JSON.stringify(temp));
          this.itemIdex = null;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>